import { CommonModule } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { BaseComponent } from 'app/com/ibm/tw/commons/mvc/base.component';
import { TxnService } from 'app/services';
import { CommandButtonModule } from 'ui-components/button';
import { MessagesModule } from 'ui-components/messages';
import { PopupModule } from 'ui-components/popup';

@Component({
    standalone: true,
    templateUrl: 'ppal.login.component.html',
    imports: [
        CommonModule,
        PopupModule,
        CommandButtonModule,
        MessagesModule
    ]
})

export class PpalLoginComponent extends BaseComponent implements OnInit, OnDestroy {

    closedFlag: boolean = false;
    timer: any;
    pWin: Window;

    /** 建構子 */
    constructor(public txnService: TxnService) {
        super(txnService);
    }

    @HostListener('window:beforeunload', ['$event'])
    beforeunloadHandler(event) {
        this.closePaypal();
    }

    ngOnInit() {
        // console.log(window.opener.paypalUrl);
        // 開啟PayPal Login Url
        let ppalUrl = window.opener.paypalUrl;
        let width = 450;
        let height = 600;
        let wLeft = window.screenLeft ? window.screenLeft : window.screenX;
        let wTop = window.screenTop ? window.screenTop : window.screenY;
        let left = wLeft + (window.innerWidth / 2) - (width / 2);
        let top = wTop + (window.innerHeight / 2) - (height / 2);

        let specs = 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width='
            + width.toString() + ', height=' + height.toString() + ', top=' + top.toString() + ', left=' + left.toString();

        // console.log(specs);
        this.pWin = window.open(ppalUrl, '_ppal', specs);
        // 設定Timer
        this.timer = setInterval(this.checkPaypal.bind(this), 1000);

    }

    // 檢查 PayPal Mini Browser 是否關閉
    public checkPaypal(): void {
        if (this.pWin === null || this.pWin.closed) {
            this.closePaypal();
        }
    }

    // 關閉本視窗，強迫關閉 PayPal Mini Browser
    public closePaypal(): void {
        // prevent memory leak when component destroyed
        clearInterval(this.timer);
        if (this.pWin && !this.pWin.closed) {
            this.pWin.close();
        }
        window.close();
    }

    /**
     * Destroy
     */
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        clearInterval(this.timer);
        if (this.pWin && !this.pWin.closed) {
            this.pWin.close();
        }
    }
}
